"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseBackendOrder = parseBackendOrder;
exports.parseBackendOrders = parseBackendOrders;
exports.parseOrdermenu = parseOrdermenu;
exports.prepareFavoriteMenuItemBody = prepareFavoriteMenuItemBody;
exports.preparePlaceOrderBody = preparePlaceOrderBody;
exports.preparePreviewOrderBody = preparePreviewOrderBody;
exports.userOrdersGglocations = userOrdersGglocations;
var _moment = _interopRequireDefault(require("moment"));
var _lodash = require("lodash");
var settings = _interopRequireWildcard(require("../settings"));
var _foodUtils = require("./foodUtils");
var _orderItemUtils = require("./orderItemUtils");
var _commonUtils = require("./commonUtils");
var _paymentEnum = _interopRequireDefault(require("../enums/paymentEnum"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
  Parses ordermenus received from the backend into the format used by the fronend.
  It merges duplicate ordermenus together,denormalizes menu, and converts price to
  native JS number format.
  */

function parseOrdermenu(ordermenu) {
  var groupedOrdermenuItems = Object.values((0, _lodash.groupBy)(ordermenu, _orderItemUtils.calculateOrderPreviewItemHash));
  var mergedOrdermenuItems = groupedOrdermenuItems.map(function (ordermenuItems) {
    return ordermenuItems.map(function (ordermenuItem) {
      return _objectSpread(_objectSpread({}, ordermenuItem), {}, {
        apiId: ordermenuItem.id,
        menu: _objectSpread(_objectSpread({}, ordermenuItem.menu), {}, {
          apiId: ordermenuItem.menu.id,
          ingredients: undefined,
          ingredientServings: (0, _foodUtils.parseBackendIngredientServings)(ordermenuItem.menu.ingredients),
          ingredientBreakdown: (0, _foodUtils.parseBackendIngredientBreakdown)(ordermenuItem.menu.ingredientBreakdown)
        }),
        total: parseFloat(ordermenuItem.total, 10),
        totalTax: parseFloat(ordermenuItem.totalTax, 10),
        discountAmount: parseFloat(ordermenuItem.discountAmount, 10),
        price: parseFloat(ordermenuItem.price, 10),
        personalSettings: [ordermenuItem.personalSettings],
        customMenuSnapshot: ordermenuItem.customMenusnapshot,
        customMenusnapshot: undefined
      });
    }).reduce(function (ordermenuItemA, ordermenuItemB) {
      return _objectSpread(_objectSpread({}, ordermenuItemA), {}, {
        personalSettings: [].concat(ordermenuItemA.personalSettings, ordermenuItemB.personalSettings)
      });
    });
  });
  var orderItems = mergedOrdermenuItems.map(function (orderItem) {
    return _objectSpread(_objectSpread({}, orderItem), {}, {
      apiId: orderItem.menu.id,
      price: parseFloat(orderItem.price, 10)
    });
  });
  return orderItems;
}
function parseBackendOrder(order, countryName, countryCodeAlpha3) {
  var deliveryAddress = (0, _commonUtils.parseDeliveryAddress)(order.deliveryAddress, countryName, countryCodeAlpha3);
  var surcharges = (0, _commonUtils.groupSurcharges)(order.surcharges);
  return _objectSpread(_objectSpread({}, order), {}, {
    id: order.uuid,
    total: parseFloat(order.total, 10),
    totalTax: parseFloat(order.totalTax, 10),
    discountAmount: parseFloat(order.discountAmount, 10),
    price: parseFloat(order.price, 10),
    ordermenu: parseOrdermenu(order.ordermenu),
    pickupTime: order.ready || order.due,
    estimatedDelivery: order.estimatedDelivery || order.ready || order.due,
    surcharges: surcharges,
    deliveryAddress: deliveryAddress,
    deliveryInstruction: order.deliveryInstructions,
    cancellationRemark: order.cancellationRemark
  });
}
function prepareFavoriteMenuItemBody(_ref) {
  var orderItem = _ref.orderItem,
    name = _ref.name;
  return {
    name: name,
    personal_settings: orderItem.personalSettings[0],
    menu: orderItem.apiId,
    ingredients: (0, _foodUtils.prepareIngredientServings)(orderItem.menu.ingredientServings)
  };
}
function userOrdersGglocations(userOrdersList) {
  /* userOrders should be sorted from the most recent */
  var mostRecentGglocationIds = userOrdersList.map(function (userOrder) {
    return "".concat(userOrder.gglocationType, "_").concat(userOrder.gglocationId);
  });
  var mostFrequentGglocationIds = (0, _lodash.chain)(mostRecentGglocationIds).countBy().toPairs().sortBy(_lodash.last).reverse().map(0).value();
  return {
    mostFrequentGglocationIds: mostFrequentGglocationIds,
    mostRecentGglocationIds: mostRecentGglocationIds
  };
}
function parseBackendOrders(orders, countryName, countryCodeAlpha3) {
  var userOrderIds = [];
  var userOrders = {};
  var userOrderMenuItems = {};
  orders.map(function (order) {
    var userOrder = parseBackendOrder(order, countryName, countryCodeAlpha3);
    userOrder.ordermenu.forEach(function (menu) {
      userOrderMenuItems[menu.customMenuSnapshot] = menu;
    });
    userOrderIds.push(userOrder.id);
    userOrders[userOrder.id] = userOrder;
    return order;
  });
  return {
    userOrders: userOrders,
    userOrderIds: userOrderIds,
    userOrderMenuItems: userOrderMenuItems
  };
}
function determineDueTime(_ref2) {
  var order = _ref2.order,
    gglocation = _ref2.gglocation,
    timeSlot = _ref2.timeSlot;
  if (!gglocation && !order.orderTime) {
    return null;
  }
  if ((gglocation === null || gglocation === void 0 ? void 0 : gglocation.type) === "instant" || !gglocation) {
    if (order.orderType === "scheduled") {
      return order.orderTime && (0, _moment["default"])(order.orderTime).toISOString();
    }
  } else {
    return (0, _moment["default"])(timeSlot === null || timeSlot === void 0 ? void 0 : timeSlot.datetime).toISOString();
  }
  return null;
}
function prepareOrderRewardClaim(_ref3) {
  var userRewardUuid = _ref3.userRewardUuid,
    promoCode = _ref3.promoCode;
  if (userRewardUuid) {
    return {
      source: "l",
      param: userRewardUuid
    };
  }
  if (promoCode) {
    return {
      source: "p",
      param: promoCode
    };
  }
  return undefined;
}
function preparePaymentRequestDetails(_ref4) {
  var paymentMethod = _ref4.paymentMethod,
    price = _ref4.price;
  return [{
    operation: settings.PAYMENT_OPERATION,
    source: _paymentEnum["default"][paymentMethod.methodType],
    amount: price && price.toFixed(2),
    params: {
      payment_method_uuid: paymentMethod.id,
      token: paymentMethod.paymentMethodToken
    }
  }];
}

/* Serializes order data for submission to order api */
function prepareOrderBody(_ref5) {
  var order = _ref5.order,
    currentOrderItem = _ref5.currentOrderItem,
    gglocation = _ref5.gglocation,
    timeSlot = _ref5.timeSlot,
    userRewardUuid = _ref5.userRewardUuid,
    promoCode = _ref5.promoCode,
    preview = _ref5.preview,
    ingredientServingsPrefix = _ref5.ingredientServingsPrefix,
    diningChoice = _ref5.diningChoice,
    customerAddressId = _ref5.customerAddressId,
    version = _ref5.version;
  return {
    gglocation_id: gglocation && gglocation.gglocationId,
    gglocation_type: gglocation && gglocation.gglocationType,
    timeslot_schedule: order.timeSlotId,
    due: determineDueTime({
      order: order,
      gglocation: gglocation,
      timeSlot: timeSlot
    }),
    order_items: (0, _orderItemUtils.prepareOrderItemsBody)({
      order: order,
      currentOrderItem: currentOrderItem,
      preview: preview,
      ingredientServingsPrefix: ingredientServingsPrefix
    }),
    reward_claim: prepareOrderRewardClaim({
      userRewardUuid: userRewardUuid,
      promoCode: promoCode
    }),
    dining_choice: diningChoice,
    address_id: customerAddressId,
    order_params: {
      add_carbon_offset: order.isCarbonOffsetEnabled,
      is_take_out_with_bag: order.isTakeOutWithBagEnabled
    },
    meta: {
      landing_page: order.landingPageHistory[order.landingPageHistory.length - 1],
      source_version: version
    }
  };
}
function preparePreviewOrderBody(_ref6) {
  var order = _ref6.order,
    currentOrderItem = _ref6.currentOrderItem,
    gglocation = _ref6.gglocation,
    timeSlot = _ref6.timeSlot,
    userRewardUuid = _ref6.userRewardUuid,
    promoCode = _ref6.promoCode,
    paymentMethod = _ref6.paymentMethod,
    ingredientServingsPrefix = _ref6.ingredientServingsPrefix,
    diningChoice = _ref6.diningChoice,
    customerAddressId = _ref6.customerAddressId,
    version = _ref6.version;
  return _objectSpread(_objectSpread({}, prepareOrderBody({
    order: order,
    currentOrderItem: currentOrderItem,
    gglocation: gglocation,
    timeSlot: timeSlot,
    userRewardUuid: userRewardUuid,
    promoCode: promoCode,
    preview: true,
    ingredientServingsPrefix: ingredientServingsPrefix,
    diningChoice: diningChoice,
    customerAddressId: customerAddressId,
    version: version
  })), paymentMethod && {
    payment_request_details: preparePaymentRequestDetails({
      paymentMethod: paymentMethod
    })
  });
}
function preparePlaceOrderBody(_ref7) {
  var order = _ref7.order,
    gglocation = _ref7.gglocation,
    timeSlot = _ref7.timeSlot,
    userRewardUuid = _ref7.userRewardUuid,
    promoCode = _ref7.promoCode,
    paymentMethod = _ref7.paymentMethod,
    price = _ref7.price,
    customerAddressId = _ref7.customerAddressId,
    diningChoice = _ref7.diningChoice,
    version = _ref7.version;
  return _objectSpread(_objectSpread({}, prepareOrderBody({
    order: order,
    gglocation: gglocation,
    timeSlot: timeSlot,
    userRewardUuid: userRewardUuid,
    promoCode: promoCode,
    preview: false,
    customerAddressId: customerAddressId,
    diningChoice: diningChoice,
    version: version
  })), {}, {
    payment_request_details: paymentMethod && preparePaymentRequestDetails({
      paymentMethod: paymentMethod,
      price: price
    })
  });
}